import {uploadImage} from "../mediaUploader";

export async function handleAttributeResource(params) {
    let data = params.data;
    if (typeof params.data.icon !== 'undefined' && params.data.icon !== null && params.data.icon.rawFile instanceof File) {
        data.icon = (await uploadImage(params.data.icon, true))['@id'];
    }
    return data;
}